module.exports = __webpack_public_path__ + "static/img/下颌套.5721776a.jpg";